export const ADD_ACCOUNT = 'ADD_ACCOUNT'
export const REGISTER = 'register'
export const LOGIN = 'login'
export const MERGE_ACCOUNT = 'MERGE_ACCOUNT'
export const REMIND_ME_LATER = 'REMIND_ME_LATER'
